import { graphql } from '@/generated/gql';

export const RESPONSIBLE_USERS_QUERY = graphql(/* GraphQL */ `
  query ResponsibleUsers(
    $capabilityIds: [String!]
    $commodityGroupIds: [String!]
    $limit: Int
    $offset: Int
    $filterBy: String
  ) {
    astronaut {
      responsibleUsers(
        capabilityIds: $capabilityIds
        commodityGroupIds: $commodityGroupIds
        limit: $limit
        offset: $offset
        filterBy: $filterBy
      ) {
        id
        primarySourceReference
        availabilityStatus
        demandCount
        firstName
        isRecommended
        lastName
        profilePicture
      }
    }
  }
`);
